import React, { useState, useEffect } from 'react';
import uuid from 'uuid/v4';
import { Grid, Paper, Typography, CircularProgress } from '@material-ui/core';

import { instanceAxios } from '../../../InstanceAxios';

import CardPlanosAssinatura from './CardPlanosAssinatura';

import { useStyles } from '../RegistroBasico/styles';
import { useStyles as useBaseStyles } from '../baseStyle';

export default function SubscriptionPlans(props) {
  const classes = useStyles();
  const classesStylesBase = useBaseStyles(props);

  const [loading, setLoading] = useState(false);
  const [plans, setPlan] = useState([]);
  const [openingCompany, setOpeningsCompany] = useState(false);

  const { user } = props.location.state;
  const { portal } = props.location.state;

  useEffect(() => {
    const fetchData = async () => {
      const { openingMEICompany } = props.location.state;

      setLoading(true);
      setOpeningsCompany(openingMEICompany);

      const instance = await instanceAxios();
      await instance
        .get('/listarPlanos')
        .then(async (result) => {
          if (openingMEICompany) {
            result = await instance.get('/buscarPlanoAssinatura/1');
          } else {
            result = await instance.get('/buscarPlanoAssinatura/2');
          }

          setPlan(result.data);

          setTimeout(() => {
            setLoading(false);
          }, 900);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    };
    fetchData();
  }, []); //eslint-disable-line

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className={classesStylesBase.grid}
    >
      <Paper elevation={10} className={classesStylesBase.root}>
        <div className={classesStylesBase.logoContainer}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            className={classesStylesBase.logo}
          />
        </div>
        <Typography className={classes.header}>Planos de Assinatura</Typography>
        {loading ? (
          <CircularProgress color="primary" size={25} />
        ) : (
          <div className={classes.container}>
            <div className={classes.viewAbsolute} />
            <div className={classes.viewCards}>
              {plans.map((planItem) => {
                return (
                  <CardPlanosAssinatura
                    key={uuid()}
                    plan={planItem}
                    planDescription={planItem.descricao}
                    openingCompany={openingCompany}
                    user={user}
                    portal={portal}
                    validateCityIsApprovedENotas={async () => {
                      setLoading(true);
                      setLoading(false);
                    }}
                  />
                );
              })}
            </div>
          </div>
        )}
      </Paper>
    </Grid>
  );
}
